import {
  APPLY_JOB_LIST_REQUEST, APPLY_JOB_LIST_FAIL, APPLY_JOB_LIST_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const ApplyJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPLY_JOB_LIST_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case APPLY_JOB_LIST_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case APPLY_JOB_LIST_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default ApplyJobReducer;
